import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ExportExport = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <g>
      <path
        d="M20.5,9h-5C15.2,9,15,9.2,15,9.5c0,0.3,0.2,0.5,0.5,0.5H20v10H3V10h4.5C7.8,10,8,9.8,8,9.5C8,9.2,7.8,9,7.5,9h-5
			C2.2,9,2,9.2,2,9.5v11C2,20.8,2.2,21,2.5,21h18c0.3,0,0.5-0.2,0.5-0.5v-11C21,9.2,20.8,9,20.5,9z"
      />
      <path
        d="M8.9,5.9L11,3.7v8.8c0,2.3,1.2,3.5,3.5,3.5v0h2c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5h-2v0c-1.7,0-2.5-0.8-2.5-2.5
			V3.7l2.1,2.1c0.2,0.2,0.5,0.2,0.7,0C15,5.8,15,5.6,15,5.5c0-0.1,0-0.3-0.1-0.4l-3-3c-0.2-0.2-0.5-0.2-0.7,0l-3,3
			C8,5.3,8,5.7,8.1,5.9S8.7,6,8.9,5.9z"
      />
    </g>
  </SvgIcon>
);

export default ExportExport;
